module.exports = __webpack_public_path__ + "static/img/gsjj.f753ecb.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/gsjj.png
// module id = e0ne
// module chunks = 0